import { render, staticRenderFns } from "./AppRecommendationSection.vue?vue&type=template&id=246bca9f&scoped=true"
import script from "./AppRecommendationSection.vue?vue&type=script&lang=js"
export * from "./AppRecommendationSection.vue?vue&type=script&lang=js"
import style0 from "./AppRecommendationSection.vue?vue&type=style&index=0&id=246bca9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bca9f",
  null
  
)

export default component.exports